import { createSelector } from 'reselect';
import { createFeatureSelector } from 'common/create-feature-selector';
import { RootState, Dispatch } from 'store';
import { getDomain, getHostname, getRegion } from 'utils';
import { FetchModelProps } from 'features/page-model/types';
import { fetchModelThunk } from './page-model-slice';
import { GetModelParams } from './api';

export const rootSelector = createFeatureSelector('pageModel');
export const getModelJson = createSelector(rootSelector, s => s.data);
export const getBreadcrumbs = createSelector(getModelJson, m => m?.breadcrumbs);
export const getSeoDescription = createSelector(getModelJson, m => m?.seoProperties.seotext);
export const getSeoH1 = createSelector(getModelJson, m => m?.seoProperties.h1);
export const getAnalytics = createSelector(getModelJson, m => m?.analytics || {});
export const getSeoProperties = createSelector(getModelJson, m => m?.seoProperties);
export const getRegionId = createSelector(getModelJson, m => m?.properties.regionId);
export const getWarningMessage = createSelector(getModelJson, m => m?.warningMessage);
export const getModelErrorCode = createSelector(rootSelector, s => s.errorCode);
export const getTitle = createSelector(getModelJson, m => m?.properties.title);

export const getRawHtml = createSelector(getModelJson, m => m?.['raw-html']);

export const getVideoLink = createSelector(getModelJson, m => m?.['video-link']);

export const getAppendixList = createSelector(getModelJson, m => m?.appendixList);

export const fetchModel = () => async (dispatch: Dispatch, getState: () => RootState) => {
  const state = getState();
  const hostname = getHostname(state.host || '');
  const domain = getDomain(hostname);
  const region = getRegion(hostname, domain);
  const pathname = state.router?.path;
  const host = state.env.ORCHESTRATOR_HOST;
  const config = {
    headers: {
      Accept: 'application/json, text/plain, */*',
      'Content-Type': 'application/json;charset=UTF-8',
      'x-api-key': state.env.API_KEY,
    },
  };
  const params: FetchModelProps = {
    pathname,
    region,
  };
  const options: GetModelParams = {
    host,
    params,
    config,
  };

  return dispatch(fetchModelThunk(options));
};
